<template>

    <body style="direction: rtl; text-align: right; padding: 70px 0px 0 0px;">
        <div class="container mb-4">
            <Header pageTitle="الاشعارات" />

            <div class="notifications">
                <div class="chat-card mb-3">
                    <div class="d-flex align-items-center">
                        <div class="icon-circle ms-3">
                            <i class="fa-solid fa-bell"></i>
                        </div>
                        <div class="chat-info">
                            <p><strong>طلب خدمة جديد</strong></p>
                            <p>لديك طلب خدمة جديد من العميل محمد.</p>
                            <p class="text-muted">2024-12-23</p>
                        </div>
                    </div>
                </div>

                <div class="chat-card mb-3">
                    <div class="d-flex align-items-center">
                        <div class="icon-circle ms-3">
                            <i class="fa-solid fa-bell"></i>
                        </div>
                        <div class="chat-info">
                            <p><strong>تم قبول الخدمة</strong></p>
                            <p>تم قبول طلبات الخدمة التصميم الجرافيكي.</p>
                            <p class="text-muted">2024-12-22</p>
                        </div>
                    </div>
                </div>

                <div class="chat-card mb-3">
                    <div class="d-flex align-items-center">
                        <div class="icon-circle ms-3">
                            <i class="fa-solid fa-bell"></i>
                        </div>
                        <div class="chat-info">
                            <p><strong>تم إرسال رسالة</strong></p>
                            <p>لقد تلقيت رسالة جديدة من العميل أحمد.</p>
                            <p class="text-muted">2024-12-21</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </body>
</template>

<script>
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";

export default {
    name: "NotificationsPage",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            // يمكنك إضافة بيانات ديناميكية هنا إذا لزم الأمر
        };
    },
};
</script>

<style scoped>
.chat-card {
    background-color: #fff;
    border: 1px solid #dee2e6;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
}

.icon-circle {
    width: 50px;
    height: 50px;
    background-color: #f0f0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-circle i {
    font-size: 1.2rem;
    color: #333;
}

.chat-info p {
    margin: 0;
}

.text-muted {
    color: #6c757d;
}
</style>